module.exports = __webpack_public_path__ + "media/banner.20f37bbd.webm";